// ⚠️ NOTA: adminUserService temporariamente simplificado
// Gerenciamento de usuários admin pode ser feito via PHP admin panel no futuro

import { apiService } from './apiService';

export const adminUserService = {
  async getAllAdmins() {
    console.warn('adminUserService.getAllAdmins não implementado');
    return [];
  },

  async createAdmin(username, password, fullName) {
    throw new Error('Admin creation not available via HTTP API');
  },

  async updateAdmin(adminId, updates) {
    throw new Error('Admin update not available via HTTP API');
  },

  async deleteAdmin(adminId) {
    throw new Error('Admin deletion not available via HTTP API');
  },

  async resetAdminPassword(adminId, newPassword) {
    throw new Error('Password reset not available via HTTP API');
  }
};
